import React from "react"
import {Row, Col} from "react-bootstrap"
import { useNavigate } from 'react-router-dom'
import { useSelector} from "react-redux"
import ListaStart from "../Regulamin/lista_start"
import KonkursInfo from "../Konkursy/konkurs_informacja"
import Uczestnik from "./uczestnik"
import BladLog from "./BladLogowania"

const Start = () => {
    const nawigacja = useNavigate()
    const id        = useSelector((magazyn) => magazyn.opcje)
    const token = sessionStorage.getItem('token')
    const powrot = () => {
        sessionStorage.clear()
        let url = '/'
        nawigacja(url)
   }
   const start = () => {
    let url = '/pytanie'
    nawigacja(url)
}
    if (id.start){nawigacja('/pytanie')}
    return (
        <Row>
        {!token ? <BladLog/> :
        <Row>
        <Uczestnik/>
        <KonkursInfo/>
        <ListaStart/>
        <Col xs={6}>
        <button className="btn btn-primary btn-lg btn-block mt-2 przycisk"
                    onClick={powrot}>Rezygnacja</button>
        </Col>
        <Col xs={6}>
        <button className="btn btn-primary btn-lg btn-block mt-2 przycisk"
                    onClick={start}> Start</button>
        </Col>
    </Row>
                }
            </Row>
        )
}

export default Start